module.exports = __webpack_public_path__ + "static/media/flipchart_loesung.57ab94b9.png";